module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3"
  }, [_c('h1', [_vm._v("Pagina niet gevonden")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tDe pagina die u zoekt kon niet worden gevonden.\n\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5fad2d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/404.vue
// module id = 1313
// module chunks = 1